<template>
	<div>
		<!-- 第一列 -->
		<el-form class="left" ref="defForm" :rules="rules" :model="defForm" label-width="120px">
			<el-form-item label="律师姓名" prop="name">
				<el-input v-model="defForm.name" placeholder="请输入律师姓名"></el-input>
			</el-form-item>
			<el-form-item label="职位" prop="relationship_id">
				<el-select v-model="defForm.relationship_id" placeholder="请选择职位" filterable   >
					<el-option
						v-for="item in relationshipList"
						:key="item.id"
						:label="item.label"
						:value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="律所地址" prop="company_address">
				<el-input v-model="defForm.company_address" placeholder="请输入律所地址"></el-input>
			</el-form-item>
			<el-form-item label="电子邮箱" prop="email">
				<el-input v-model="defForm.email" placeholder="请输入电子邮箱"></el-input>
			</el-form-item>
			<el-form-item label="业务专长" prop="services">
				<el-select v-model="defForm.services" placeholder="请选择业务" filterable  multiple  >
					<el-option
						v-for="item in treeData"
						:key="item.id"
						:label="item.title"
						:value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="简介" prop="content">
				<el-input type="textarea" label="简介" v-model="defForm.content" :show-word-limit="true" maxlength="255" :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
			</el-form-item>
			<el-form-item label="执业经验" prop="practicing_experience">
				<el-input type="textarea" v-model="defForm.practicing_experience" :show-word-limit="true" maxlength="255" :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
			</el-form-item>
			<el-form-item label="工作经历" prop="work_experience">
				<el-input type="textarea" v-model="defForm.work_experience" :show-word-limit="true" maxlength="255" :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
			</el-form-item>	
			<!-- <el-form-item label="发布时间" prop="publish">
				<el-date-picker
					v-model="defForm.publish" 
					type="date" 
					value-format="yyyy-MM-dd HH:MM:SS"
					placeholder="请输入发布日期" >
				</el-date-picker>
			</el-form-item> -->
			<el-form-item label="排序码" prop="sort">
				<el-input v-model="defForm.sort" type="number" placeholder="请输入排序码"></el-input>

			</el-form-item>
		</el-form>
		<!-- 第二列 -->
		<el-form class="right" ref="defForm2" :rules="rules" :model="defForm" label-width="120px">
			<el-form-item label="大学" prop="university">
				<el-input v-model="defForm.university" placeholder="请输入大学名称"></el-input>
			</el-form-item>
			<el-form-item label="学历" prop="education">
				<el-select v-model="defForm.education" placeholder="请选择学历" filterable >
					<el-option
						v-for="item in [{name:'专科'},{name:'本科'},{name:'研究生'},{name:'博士'},{name:'博士后'},{name:'院士'}]"
						:key="item.name"
						:label="item.name"
						:value="item.name">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="联系方式" prop="phone">
				<el-input v-model="defForm.phone" placeholder="请输入联系方式"></el-input>
			</el-form-item>
			<el-form-item label="图片" prop="image">
				<el-upload class="avatar-uploader" 
					action="string" 
					:show-file-list="false" 
					:http-request="uploadImg"
					:before-upload="beforeAvatarUpload">
					<img v-if="defForm.image" :src="defForm.image" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-form-item>	
			<el-form-item label="执业领域" prop="practice_areas">
				<el-input type="textarea" v-model="defForm.practice_areas" :show-word-limit="true" maxlength="255" :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
			</el-form-item>
			<el-form-item label="教育背景" prop="educational_background">
				<el-input type="textarea" v-model="defForm.educational_background" :show-word-limit="true" maxlength="255" :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
			</el-form-item>
			<el-form-item label="社会职务" prop="social_position">
				<el-input type="textarea" v-model="defForm.social_position" :show-word-limit="true" maxlength="255" :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
			</el-form-item>
			<el-form-item label="工作语言" prop="working_language">
				<el-input type="textarea" v-model="defForm.working_language" :show-word-limit="true" maxlength="255" :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
			</el-form-item>
		
		</el-form>
		<!-- 编辑器 -->
		<!-- <el-form ref="defForm3" :rules="rules" :model="defForm" label-width="120px">
			
			
		</el-form> -->
		<!-- 按钮部分 -->
		<div class="button" style="margin-left: 100px;">
			<el-button type="primary" @click="$router.back()">返回</el-button>
			<el-button type="primary" :loading="loading" @click="submitForm(defForm)">保存</el-button>
		</div>
	</div>
</template>
<script>
	import '@riophae/vue-treeselect/dist/vue-treeselect.css'
	import {create,upload} from '@/api/lawyer'
	import {queryService} from "@/api/service";
	import {queryTreeChannelByPid} from '@/api/channel'
	import token from "@/token.js";
	export default {
		name: "Add",
		data() {
			return {
				relationshipList:[],
				defForm: {
					sort:0,
					name: '',
					email:'',
					services:[],
					service_ids: '',
					relationship_id: '',
					company_address: '',
					content: '',
					practicing_experience: '',
					work_experience: '',
					university: '',
					education: '',
					phone: '',
					practice_areas: '',
					educational_background: '',
					social_position: '',
					working_language: '',
					image: '',
					publish: '',
					createUserID: token.getUser().id,
					createUserName: token.getUser().manager_username
				},
				treeData: [],
				loading: false,
				rules: {
					name: [{
						required: true,
						message: '必填项不能为空'
					}],
					sort: [{
						required: true,
						message: '必填项不能为空'
					}],
					services: [{
						required: true,
						message: '必填项不能为空'
					}],
					relationship_id: [{
						required: true,
						message: '必填项不能为空'
					}],
				}
			}
		},

		created() {
			let param = {
					page: 1,
					pageSize: 99999,
				}
			queryService(param).then(data => {
				this.treeData = data.data.list
				console.log(this.treeData)
			}).catch(error => {
				this.$message.error(error)
			})
			queryTreeChannelByPid(26).then(data => {
				this.relationshipList = data.data
				console.log(this.treeData)
			}).catch(error => {
				this.$message.error(error)
			})
		},
		methods: {
			submitForm(form) {
				this.$refs['defForm'].validate(valid => {
					if (valid) {
						if(this.defForm.services && this.defForm.services.length > 0){
							this.defForm.service_ids = this.defForm.services.toString()
						}else{
							this.defForm.service_ids = ''
						}
						console.log("新增",this.defForm)
						this.loading = true
						create(this.defForm).then(data => {
							this.loading = false
							this.$refs['defForm'].resetFields()
							this.$message.success("新增成功!")
							this.$router.push('/admin/lawyer/lawyerindex')
						}).catch(error => {
							this.loading = false
							this.$message.error(error)
						})
					}
				})
			},
			close() {
				this.$emit("hideDialog")
			},
			uploadImg(param) {
				let formData = new FormData();
				formData.append("file", param.file)
				upload(formData).then(data => {
					this.defForm.image = data.data
				}).catch(error => {
					this.$message.error(error)
				})
			},
			//上传之前的验证
			beforeAvatarUpload(file) {
				const isIMAGE = (file.type === 'image/jpeg') || (file.type === 'image/jpg') || (file.type === 'image/png')
				if (!isIMAGE) {
					this.$message.error('上传文件只能是图片格式!')
				}
				return isIMAGE 
			},
		}
	}
</script>

<style scoped>
	div ::v-deep .el-date-editor{
		width: 100%;
	}
	div ::v-deep .el-select{
		width: 100%;
	}
	.left{
		width: 50%;
		display: inline-block;
	}
	.right{
		width: 50%;
		display: inline-block;
	}
	.avatar-uploader {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		width: 80px;
		height: 80px;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 80px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 80px;
		height: 80px;
		display: block;
	}
</style>
